import axios from 'axios';

export const showsinglestdass = (obj) => async (dispatch) => {
    dispatch({type:'SHOW_SINGLE_STD_ASS',payload:obj})
}

export const emptysinglestdass = () => async (dispatch) => {
    dispatch({type:'EMPTY_SINGLE_STD_ASS'})
}

